import swaggerClient from "../remote-client";

export default class AppointmentServiceImpl {
  /**
   * Retrieve all the appointments for the given filters (not paginated)
   * @param {*} payload
   */
  callGetAppointmentsSearch(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.postAppointmentsSearch(
            {},
            swaggerClient.buildRequest(payload),
            {}
          );
        })
        .then(result => {
          let appointments = [];
          let numberOfAppointments = 0;
          if (result.body?.appointmentList) {
            numberOfAppointments = result.body.numberOfAppointments;
            appointments = result.body.appointmentList;
          }
          resolve({
            appointments: appointments,
            numberOfAppointments: numberOfAppointments
          });
        })
        .catch(error => reject(error));
    });
  }

  /**
   * Requests appointment with id
   * @param {*} id
   */
  getAppointment(id) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getAppointmentWithId(
          { id },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.appointment))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * Get member contact info
   * @param {*} appointmentId
   */
  callGetMemberContactInfo(appointmentId) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getAppointmentWithAppointmentIdContactInfo(
          { appointmentId },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.contactInfo))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * Retrieve the next X appointments with state ACCEPTED
   */
  callGetNextAppointments(num) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient
        .then(client => {
          return client.apis.Appointment.getAppointmentsNextWithNum(
            { num: num },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(result => {
          let appointments = [];
          let numberOfAppointments = 0;
          let hasAlmostOneFondoEstAppointment = false;
          if (result.body?.appointmentList) {
            numberOfAppointments = result.body.numberOfAppointments;
            appointments = result.body.appointmentList;
            hasAlmostOneFondoEstAppointment =
              result.body.hasAlmostOneFondoEstAppointment;
          }
          resolve({
            appointments: appointments,
            numberOfAppointments: numberOfAppointments,
            hasAlmostOneFondoEstAppointment: hasAlmostOneFondoEstAppointment
          });
        })
        .catch(error => reject(error));
    });
  }

  sendAppointment(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointment(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * Cancels the appointment
   * @param {*} payload
   */
  cancel(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithIdCancel(
          { id: payload.id },
          swaggerClient.buildRequest({
            cancelReasonId: payload.cancelReasonId,
            cancelReasonAdditionalInfo: payload.cancelReasonAdditionalInfo
          }),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * @param {*} payload {appointmentId: '' , dataAndTime: ''}
   */
  modifyDate(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getAppointmentWithIdAcceptModifyDate(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * Accept the proposed date from the hfOffice
   * @param {*} id
   */
  acceptModifyDate(id) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getAppointmentWithIdAcceptModifyDate(
          { id: id },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  /**
   * Sets reminder for the given appointment
   * @param {*} appId
   */
  setReminder(appId) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithAppointmentIdReminder(
          { appointmentId: appId },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  createExpostAppointment(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentExpost(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  downloadVoucher(documentId) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getDocumentWithDocumentId(
          { documentId },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res))
          .catch(error => reject(error));
      });
    });
  }

  getRejectReasons(rejectReasonType) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getRejectreasonWithRejectReasonType(
          { rejectReasonType },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  modifySlotDate({ id, dateAndTime }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithIdSlotModifyDate(
          { id },
          swaggerClient.buildRequest({ dateAndTime }),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  modifyExpostDate({ id, dateAndTime }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithIdExpostModifyDate(
          { id },
          swaggerClient.buildRequest({ dateAndTime }),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  modifyTimeperiodDate({ id, memberRequestDateWithTimes }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithIdTimeperiodModifyDate(
          { id },
          swaggerClient.buildRequest({ memberRequestDateWithTimes }),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  modifyDateForMemberAvailability({ id, memberRequestDateWithTimes }) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postAppointmentWithIdTimeperiodModifyDateForMemberAvailability(
          { id },
          swaggerClient.buildRequest({ memberRequestDateWithTimes }),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  /* Save a personal note for the given paylod */
  callPostNote(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postNote(
          {},
          swaggerClient.buildRequest(payload),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }
}
